// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2Iodd","title":"Images45_title__byB3_","images":"Images45_images__3FvEC"};